import {Component, Input, OnInit} from '@angular/core';
import {EiStructureBaseComponent} from "../ei-structure-base.component";
import {EiStructureDto} from "../../../../../model/dto/entity/ei-structure.dto";


@Component({
    selector: 'ei-structure-full',
    templateUrl: 'ei-structure-full.component.html',
    standalone: false
})
export class EiStructureFullComponent extends EiStructureBaseComponent implements OnInit {

    @Input() structureDto: EiStructureDto;

    ngOnInit() {
        super.ngOnInit();
    }

    get importTypeId(): number {
        return this.structureDto?.importTypeDtoId;
    }

}
